import axios from 'axios';
import Cookies from 'js-cookie';

export const axiosInstance = axios.create({
  baseURL: `${import.meta.env.VITE_API_URL}`,
});

const MAIN_LANGUAGE_KEYS = ['mainLanguageId', 'MainLanguageId'];
const USD_CODE_ENDPOINTS = [
  '/AdminShop/CreatePromocode',
  '/AdminShop/UpdatePromocode',
  '/AdminShop/CreateProduct',
  '/AdminShop/UpdateProductMain',
  '/AdminOutstaff/CreateOutstaffItemGradeColumn',
  '/AdminOutstaff/UpdateOutstaffItemGradeColumn',
];

const isObject = (value) => value && typeof value === 'object' && !Array.isArray(value);

const shouldForceUsdCode = (url = '') => {
  return USD_CODE_ENDPOINTS.some((endpoint) => url.includes(endpoint));
};

const sanitizeData = (data, forceUsdCurrencyCode = false) => {
  if (Array.isArray(data)) {
    return data.map((item) => sanitizeData(item, forceUsdCurrencyCode));
  }

  if (!isObject(data)) {
    return data;
  }

  const result = {};

  Object.entries(data).forEach(([key, value]) => {
    if (MAIN_LANGUAGE_KEYS.includes(key)) {
      return;
    }

    if (forceUsdCurrencyCode && key === 'currencyId') {
      result.currencyCode = 'USD';
      return;
    }

    if (forceUsdCurrencyCode && key === 'CurrencyId') {
      result.CurrencyCode = 'USD';
      return;
    }

    result[key] = sanitizeData(value, forceUsdCurrencyCode);
  });

  return result;
};

const sanitizeFormData = (formData, forceUsdCurrencyCode = false) => {
  const sanitizedFormData = new FormData();

  for (const [key, value] of formData.entries()) {
    if (MAIN_LANGUAGE_KEYS.includes(key)) {
      continue;
    }

    if (typeof value === 'string') {
      try {
        const parsed = JSON.parse(value);
        const sanitizedValue = sanitizeData(parsed, forceUsdCurrencyCode);
        sanitizedFormData.append(key, JSON.stringify(sanitizedValue));
        continue;
      } catch (e) {
        // Оставляем строковые поля как есть, если это не JSON
      }
    }

    sanitizedFormData.append(key, value);
  }

  return sanitizedFormData;
};

axiosInstance.interceptors.request.use((config) => {
  const forceUsdCurrencyCode = shouldForceUsdCode(config.url);

  if (config.params) {
    config.params = sanitizeData(config.params, false);
  }

  // Если данные являются FormData, не устанавливаем Content-Type
  // Браузер автоматически установит правильный Content-Type с boundary
  if (config.data instanceof FormData) {
    config.data = sanitizeFormData(config.data, forceUsdCurrencyCode);
    config.headers['Content-Type'] = 'multipart/form-data';
    return config;
  }

  if (config.data && (isObject(config.data) || Array.isArray(config.data))) {
    config.data = sanitizeData(config.data, forceUsdCurrencyCode);
  }

  return config;
});

axiosInstance.interceptors.response.use(
  async function (response) {
    if (response.data.success === true) {
      return response.data.value;
    } else {
      if (response.data.code === 401) {
        Cookies.remove('sid');
        Cookies.remove('refreshToken');
        Cookies.remove('expiredAt');
        window.location.assign('/login');
      }

      if (response.data.code === 404 && response.data.error === 'Токен в системе не найден') {
        Cookies.remove('sid');
        Cookies.remove('refreshToken');
        Cookies.remove('expiredAt');
        window.location.assign('/login');
      }

      if (response.data.code === 403) {
        if (
          response.data.error === 'Сессия была деактивирована' ||
          response.data.error === 'У пользователя нет доступа в администраторскую панель'
        ) {
          Cookies.remove('sid');
          Cookies.remove('refreshToken');
          Cookies.remove('expiredAt');
          window.location.assign(
            response.data.error === 'У пользователя нет доступа в администраторскую панель'
              ? '/403'
              : '/login',
          );
        }
      }
      throw response.data;
    }
  },
  function (error) {
    return Promise.reject(error);
  },
  null,
  { synchronous: false },
);
